module.exports = __webpack_public_path__ + "static/media/womanl.90afb629.jpg";